const calculations = {
    aboutBrand: 1.5,
    campaignDetails: 1.5,
    targetAudience: 1,
    mediaPreferences: 0.5,
    mediaSpecificDetails: 0.5,
    campaignBrief: 1,
    competitionAndMedia: 1,
    systemRecommendation: 1,
    plannerRecommendation: 2
};
function feedbackCalculation(data) {
    let sum = 0;
    Object.keys(data).map((item) => {
        if (data[item].rating === 3) {
            sum = sum + calculations[item];
        }
        return sum;
    });
    return Object.keys(data).some((item) => data[item].rating === 1)
        ? 0
        : sum;
}
export default feedbackCalculation;
